import { WatchQueryFetchPolicy } from '@apollo/client';
import { useState, useEffect } from 'react';

const useNoCacheOnServerFetchPolicy = () => {
  const [fetchPolicy, setFetchPolicy] = useState('no-cache');

  useEffect(() => {
    setFetchPolicy('cache-and-network');
  }, []);

  return fetchPolicy as WatchQueryFetchPolicy | undefined;
};

export default useNoCacheOnServerFetchPolicy;
